import * as React from 'react';
import { observer } from 'mobx-react';
import { TrackersData } from 'data/TrackersData';
import { UIState } from 'data/UIState';
import { DailyTracker } from 'components/mywellness/DailyTracker';
import { computed, observable } from 'mobx';
import { GraphedTracker } from 'components/mywellness/weekly-graph/GraphedTracker';
import { DayLabels } from 'components/mywellness/weekly-graph/DayLabels';
import { GraphNav } from 'components/mywellness/weekly-graph/GraphNav';


import './TrackersSubPage.pcss';

@observer
class TrackersSubPage extends React.Component {
  @observable daily:boolean = true;
  render() {
    if(UIState.isTrackers) {
      if(TrackersData.isZeroState) {
        return <ZeroTrackers />;
      } else {
        return (
          <React.Fragment>
            <div className="trackersTabBar">
              <button className={`${this.daily?'selected':''}`} onClick={()=>{ this.daily = true; }}><i className="fa fa-bars"></i> Daily</button>
              <button className={`${this.daily?'':'selected'}`} onClick={()=>{ this.daily = false; }}><i className="fa fa-bar-chart"></i> Graphs</button>
            </div>  
            <Daily visible={this.daily} />
            <Graphs visible={!this.daily} />
          </React.Fragment>
        );
      }
    } else {
      return null;
    }
  }
} 



@observer
class Graphs extends React.Component<{visible:boolean}> {
  render() {
    return (!this.props.visible ? null :
      <React.Fragment>
        <div className="graphNavWrapper">
          <GraphNav />
        </div>
        <div className="graphedTopper">
          <div className="leftPush"></div>
          <DayLabels />
        </div>
        <div className="graphedTrackers">
          {TrackersData.activeTrackers.map(tracker=><GraphedTracker key={tracker.id} tracker={tracker} />)}
        </div>        
        <ManageTrackersButton />
      </React.Fragment>
    );
  }
}












@observer
class Daily extends React.Component<{visible:boolean}> {

  @computed
  get dailyDateString() {
    return TrackersData.dailyMoment.format('M/D');
  }

  render() {
    return (!this.props.visible ? null :
      <React.Fragment>
        <div className="trackersNav">
          <button onClick={TrackersData.subtractDayFromDailyMoment} className={`${TrackersData.dailyMomentIsFirstPortalMoment ? 'disabled':''}`}><i className="fa fa-chevron-left"></i></button>
          <div className="status">
            {TrackersData.dailyMomentIsToday && <span>Today </span> }
            {this.dailyDateString}
          </div>
          <button onClick={TrackersData.addDayToDailyMoment} className={`${TrackersData.dailyMomentIsToday ? 'disabled':''}`}><i className="fa fa-chevron-right"></i></button>
        </div>  
        <div className="dailyTrackers">
          {TrackersData.activeTrackers.map(tracker=><DailyTracker key={tracker.id} tracker={tracker} />)}
          <ManageTrackersButton />
        </div>
      </React.Fragment>
    );
  }
}


const ZeroTrackers = () =>
  <div className="trackersZero">
    <div className="zcontent">
      <p>
        <strong>You haven't added any trackers</strong><br/>
        Track daily goals, view weekly graphs and gain insight over time.
      </p>
      <ManageTrackersButton />
    </div>
  </div>  
;


const ManageTrackersButton = () =>
  <div className="managerTracker"><button onClick={()=>{ TrackersData.showManageTrackersSubPage = true; }}><i className="material-icons">settings</i>MANAGE TRACKERS</button></div>  
;





export { TrackersSubPage };
